import { render } from "./EditZombieModal.vue?vue&type=template&id=92a16352"
import script from "./EditZombieModal.vue?vue&type=script&lang=js"
export * from "./EditZombieModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__